import React, { useState, useEffect } from "react";
import "./LeadsInfoTable.css";
import {
  ownLead,
  withDrawLead,
  submitFAQ,
  changeFaqData,
  loadMoreData,
  submitDemoSchedule,
  statusQuestionData,
  getLeadData,
  personalQuestionData,
  getHistoryData,
  getLeadDataFilter,
  getAllCourses,
  SendChangeCourse,
  SendUserName,
  SendMessageToAllTutors,
  intrestedTeachers,
  confirmTutor
} from "../../../actions/emActions";
import { validateMonth, validateDate, makeFirstLetterCapital } from "../../../actions/utility"
import { connect } from "react-redux";
import Snackbar from "../../Snackbar";
import $ from "jquery";
import DatePicker from "react-datepicker";
import { Nav, NavLink, NavItem, TabContent, TabPane } from "reactstrap";
import "react-datepicker/dist/react-datepicker.css";
import StatusQuestion from "./StatusQuestion";
import HistoryTab from "./HistoryTab";
import SearchSection from "./SearchSection";
import moment from "moment";

const LeadsInfoTable = (props) => {
  const { mapoverLeads, myLeadsArray, reservedArray, faqData, convertedLeads, allLeads, availableDemoStatus, getLeadDataFilter, loggedUserId } = props;
  const [snackbarMessage, setsnackbarMessage] = useState("");
  const [snackbarColor, setsnackbarColor] = useState("#01ac8a");
  const [loadmoreloader, setloadmoreloader] = useState(false);
  const [loadCount, setloadCount] = useState(2);
  const [programId, setprogramId] = useState("");
  const [programName, setprogramName] = useState("");
  const [tutorName, settutorName] = useState("");
  const [tutotImage, settutotImage] = useState("");
  const [timingsArray, settimingsArray] = useState([]);
  const [selectedTimeTable, setselectedTimeTable] = useState("");
  const [tempData, settempData] = useState(faqData);
  const [startDate, setstartDate] = useState(new Date());
  const [demoDate, setdemoDate] = useState("");
  const [demoTime, setdemoTime] = useState("");
  const [studentId, setstudentId] = useState("");
  const [teacherId, setteacherId] = useState("");
  const [courseId, setcourseId] = useState("");
  const [phoneNumber, setphoneNumber] = useState("");
  const [disableDays, setdisableDays] = useState([]);
  const [activeTab, setactiveTab] = useState("wip");
  const [historyData, sethistoryData] = useState("");
  const [personalQuestion, setpersonalQuestion] = useState("");
  const [keyWord, setkeyWord] = useState("");
  const [selectedStatus, setselectedStatus] = useState("");
  const [filterLoading, setfilterLoading] = useState(false);
  const [fomoPictures, setfomoPictures] = useState([]);
  const [grades, setgrades] = useState([]);
  const [courseName, setcourseName] = useState("");
  const [selectedGrade, setselectedGrade] = useState("");
  const [timingsTeachers, settimingsTeachers] = useState([]);
  const [sortedCourses, setsortedCourses] = useState();
  const [selectedOrderId, setselectedOrderId] = useState('');
  const [selectedLeadId, setselectedLeadId] = useState(0);
  const [selectedEmId, setselectedEmId] = useState(0);
  const [addUserName, setaddUserName] = useState('');
  const [selecteCourseTab, setselecteCourseTab] = useState(1);
  const [demoDateForTeacher, setdemoDateForTeacher] = useState(new Date());
  const [intrestedTeachers, setintrestedTeachers] = useState([]);
  const [classRequestId, setclassRequestId] = useState('');
  const [teacherIdInterest, setteacherIdInterest] = useState('');
  const [initialQuestionsData, setinitialQuestionsData] = useState({
    parentName: '',
    whereLive: '',
    schoolName: '',
    challengesFace: [
      {
        id: 1,
        title: 'Weak concepts',
        checked: false,
      },
      {
        id: 2,
        title: 'Advance Learning',
        checked: false,
      },
      {
        id: 3,
        title: 'Homework help',
        checked: false,
      },
      {
        id: 4,
        title: 'Exam prep',
        checked: false,
      },
      {
        id: 5,
        title: 'Child has Learning Disability',
        checked: false,
      }
    ],
    tutoringOption: [
      {
        id: 1,
        title: 'Group classes',
        checked: false,
      },
      {
        id: 2,
        title: '1 on 1 classes',
        checked: false,
      },
      {
        id: 3,
        title: 'Exam prep classes',
        checked: false,
      },
      {
        id: 4,
        title: 'Homeschooling',
        checked: false,
      }
    ],
    notes: ''
  });
  const [notConvertingQuestion, setnotConvertingQuestion] = useState([
    {
      id: 1,
      title: 'Scheduling conflict',
      checked: false,
    },
    {
      id: 2,
      title: 'Pricing',
      checked: false,
    },
    {
      id: 3,
      title: 'Too burdensome for my child',
      checked: false,
    },
    {
      id: 4,
      title: 'Payment mechanism',
      checked: false,
    },
    {
      id: 5,
      title: "I didn't like the teacher",
      checked: false,
    },
    {
      id: 6,
      title: "Not now, maybe later",
      checked: false,
    },
    {
      id: 7,
      title: "Don't have the right technology or internet connection",
      checked: false,
    },
    {
      id: 8,
      title: "Signed up by mistake",
      checked: false,
    },
    {
      id: 9,
      title: "Not looking for tutoring at this time",
      checked: false,
    },
    {
      id: 10,
      title: "Already enrolled in other tutoring service",
      checked: false,
    },
    {
      id: 11,
      title: "Looking for physical classes, not online",
      checked: false,
    },
  ]);
  const [FAQQuestions, setFAQQuestions] = useState([
    {
      title: "Do you want to pay and continue?",
      sel_opt: "",
    },
    {
      title: "Preferred payment type?",
      sel_opt: "",
    },
    {
      title: "What would be the joining date?",
      sel_opt: "",
    },
  ]);

  let getLeadData = [...mapoverLeads];
  let afterLeadData = getLeadData.map((item, index) => {
    return {
      program: item.course_name,
      demo: validateMonth(item.ts),
      time: new Date(item.ts).toLocaleTimeString('en-US').replace(/:\d+ /, ' '),
      // demo: new Date(item.demo_date).toLocaleString("default", {
      //   month: "short",
      // }),
      date: validateDate(item.ts),
      year: new Date(item.ts).getFullYear(),
      ParentName: item.parent_name,
      phoneNumber: item.parent_contact,
      user_id: item.user_id,
      demo_id: item.demo_id,
      course_id: item.course_id,
      teachers_info: JSON.parse(item.teachers_info),
      timing: JSON.parse(item.timing),
      is_scheduled_demo: item.is_scheduled_demo,
      scheduled_date_time: item.scheduled_date_time,
      not_interested: item.not_interested,
      spam: item.spam,
      demo_status: item.demo_status,
      curriculum_img: item.curriculum_img,
      web_identifier: item.web_identifier,
      timingTeachers: item.timingTeachers,
      orderid: item.orderid,
      prog_id: item.prog_id,
      no_response: item.no_response,
      waiting_list: item.waiting_list,
      ownership:
        typeof convertedLeads[item.demo_id] == "undefined" ?
          typeof myLeadsArray[item.demo_id] !== "undefined"
            ? "mine"
            : typeof reservedArray[item.demo_id] !== "undefined"
              ? "taken"
              : "available" : "converted",
      emName:
        typeof reservedArray[item.demo_id] !== "undefined"
          ? reservedArray[item.demo_id].agentData.agent_name
          : "",

      emPicture:
        typeof reservedArray[item.demo_id] !== "undefined" &&
          reservedArray[item.demo_id].agentData.agent_image !== null
          ? `https://lincolnmethod.s3.us-east-1.amazonaws.com/profileImages/${reservedArray[item.demo_id].agentData.agent_image
          }`
          : "",

      studentName: item.user_name,
      em_id: item.em_id,
      referrer: item.referrer,
      status:
        typeof convertedLeads[item.demo_id] == "undefined" ?
          typeof myLeadsArray[item.demo_id] !== "undefined"
            ? "Initial Call"
            : typeof reservedArray[item.demo_id] !== "undefined"
              ? "Initial Call"
              : "Signup" : "converted",
      // studentName: makeFirstLetterCapital(item.first_name) + " " + makeFirstLetterCapital(item.last_name)
    };
  });

  useEffect(() => {
    props.getAllCourses()
      .then((res) => {
        var sortedCoursesArray = [];
        var coursesKeys = Object.keys(res.data.result.gradescourses);
        coursesKeys.map(course => {

          var gradeArray = [];
          var courseKey = Object.keys(res.data.result.gradescourses[course]);
          var gradeName = res.data.result.gradescourses[course][courseKey[0]].grade;
          courseKey.map(_course => {
            var thisCourse = res.data.result.gradescourses[course][_course];
            gradeArray.push(thisCourse);
          })
          sortedCoursesArray.push({
            grade: gradeName,
            courses: gradeArray,
            visible: true
          })

          setgrades(coursesKeys)
        })
        setsortedCourses(sortedCoursesArray)
      })

      const studentName = window.localStorage.getItem("searchStudent");
      if(studentName && studentName) {
        debugger;
        applyFilter(studentName, null);
      }
  }, [])

  const changeCourseFunc = (e) => {
    if (courseName !== "") {
      debugger;
      sortedCourses.map(_grade => {
        if (_grade.grade == selectedGrade) {

          console.log(_grade)
          debugger;
          _grade.courses.map(course => {
            if (course.course_name.indexOf(courseName) > -1) {

              props.SendChangeCourse(studentId, selectedEmId, course.id, selectedLeadId, selectedOrderId)
                .then((res) => {
                  $(`#changeCourseModal`).modal('toggle');
                  window.location.reload();
                  debugger;
                })
                .catch((err) => {
                  debugger;
                })
              console.log("Course Id", course.id)
            }
          })
        }
      })
    }

  }

  const onChangeSubbjectForKGS = (e) => {
    if (e.target.value === "Grade 3 KGS admission prep") {
      setselectedGrade("4M9G0NDB5rZ5Jd3");
    }
    else if (e.target.value === "Grade 7 KGS admission prep") {
      setselectedGrade("ba9Mz7Z6b7OERm0");
    }
    else if (e.target.value === "Grade 10 KGS admission prep") {
      setselectedGrade("5k3vgrJZErB80Yp");
    }
    else if (e.target.value === "Nursery KGS admission prep") {
      setselectedGrade("JlpzM7nj579LGQk");
    }
  }

  const changeCourseFuncForKGS = (e) => {
    debugger;
    props.SendChangeCourse(studentId, selectedEmId, selectedGrade, selectedLeadId, selectedOrderId)
      .then((res) => {
        $(`#changeCourseModal`).modal('toggle');
        window.location.reload();
        debugger;
      })
      .catch((err) => {
        debugger;
      })

  }

  useEffect(() => {
    $('#myTab a').on('click', function (e) {
      e.preventDefault()
      $(this).tab('show')
    })
  })
  const snackBarFunction = () => {
    var x = document.getElementById("snackbar");
    x.className = "show";
    setTimeout(function () {
      x.className = x.className.replace("show", "");
    }, 3000);
  };

  const OwnIt = (demoId) => {
    const { loggedUserId } = props;
    props.ownLead(loggedUserId, demoId).then((success) => {
      if (success.data.status == "success") {
        setsnackbarMessage("Owned Successfully");
        setsnackbarColor("#01ac8a")
        snackBarFunction();
      }
    });
  };

  const WithdrawIt = (demoId, demouserId, courseId) => {
    const { loggedUserId } = props;
    props
      .withDrawLead(loggedUserId, demoId, demouserId, courseId)
      .then((success) => {
        debugger;
        if (success.data.status == "success") {
          setsnackbarMessage("Withdraw Successfully");
          setsnackbarColor("#01ac8a")
          snackBarFunction();
        }
      });
  };

  const newChangeQuestion = (e, demoId) => {
    FAQQuestions.map((item, index) => {
      if (item.title == e.target.title) {
        item.sel_opt = e.target.value;
      } else {
      }
    });

    var data = { [demoId]: JSON.stringify([...FAQQuestions]) };
    console.log(data);
    settempData({ ...data, ...faqData });
    setFAQQuestions([...FAQQuestions]);
    if (e.target.value == "No") {
      setsnackbarMessage("Can't Proceed Further, Click Yes to continue");
      setsnackbarColor("#E61610")
      snackBarFunction();
    }
  };

  const submitFAQ = (demoUser_id, courseId, demoId) => {
    const { loggedUserId } = props;
    props
      .submitFAQ(loggedUserId, demoUser_id, courseId, demoId, FAQQuestions)
      .then((success) => {
        if (success.data.status == "success") {
          setsnackbarMessage("Response is added successfully");
          snackBarFunction();
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        }
      });
  };

  const loadMoreFunction = () => {
    const { loggedUserId } = props;
    setloadmoreloader(true);
    props.loadMoreData(loggedUserId, loadCount, selectedStatus, keyWord).then((res) => {
      setloadmoreloader(false);
      setloadCount(loadCount + 1);
    });
  };
  // useEffect(() => {
  //   $(window).on('resize', function () {
  //     if ($(window).width() < 411) {
  //       $('#body').addClass('table-responsive');
  //       $('#body').removeClass('jj');
  //     } else {
  //       $('#body').addClass('jj');
  //       $('#body').removeClass('table-responsive');
  //     }
  //   })
  // })

  const onDateChange = (date) => {
    setdemoDate(date);
    var weekDay = date.getDay();

    Object.keys(selectedTimeTable).map((item) => {
      var day = selectedTimeTable[item];

      if (day.day === "Monday" && weekDay === 1) {
        setdemoTime(day.start);
      }
      else if (day.day === "Tuesday" && weekDay === 2) {
        setdemoTime(day.start);
      }
      else if (day.day === "Wednesday" && weekDay === 3) {
        setdemoTime(day.start);
      }
      else if (day.day === "Thursday" && weekDay === 4) {
        setdemoTime(day.start);
      }
      else if (day.day === "Friday" && weekDay === 5) {
        setdemoTime(day.start);
      }
      else if (day.day === "Saturday" && weekDay === 6) {
        setdemoTime(day.start);
      }
      else if (day.day === "Sunday" && weekDay === 0) {
        setdemoTime(day.start);
      }
    })
  }

  const courseModalData = (itemData) => {
    debugger;
    setstudentId(itemData.user_id);
    setselectedLeadId(itemData.demo_id)
    setselectedOrderId(itemData.orderid)
    var LoginData = JSON.parse(localStorage.getItem("loginData"));
    setselectedEmId(LoginData.user.id);
  }
  const modalData = (item) => {
    setprogramName(item.program);
    setselectedLeadId(item.demo_id);
    setprogramId(item.prog_id);
    var LoginData = JSON.parse(localStorage.getItem("loginData"));
    setselectedEmId(LoginData.user.id);
    settutorName(item.teachers_info[0]['name']);
    settutotImage(item.teachers_info[0]['img_src']);
    setteacherId(item.teachers_info[0]['teacherid']);
    setstudentId(item.user_id);
    setcourseId(item.course_id);
    setphoneNumber(item.phoneNumber);
    setselectedTimeTable(item.timing);
    settimingsTeachers(item.timingTeachers)
    debugger;
    const timingClone = [];
    const disableDaysClone = [];
    Object.keys(item.timing).map((id, key) => {
      var day = item.timing[id];

      //making logic for disable Days
      if (day.day.includes("Sunday") && day.is_on) {
        disableDaysClone.push(0)
      }
      else if (day.day.includes("Monday") && day.is_on) {
        disableDaysClone.push(1)
      }
      else if (day.day.includes("Tuesday") && day.is_on) {
        disableDaysClone.push(2)
      }
      else if (day.day.includes("Wednesday") && day.is_on) {
        disableDaysClone.push(3)
      }
      else if (day.day.includes("Thursday") && day.is_on) {
        disableDaysClone.push(4)
      }
      else if (day.day.includes("Friday") && day.is_on) {
        disableDaysClone.push(5)
      }
      else if (day.day.includes("Saturday") && day.is_on) {
        disableDaysClone.push(6)
      }

      //Logic for timetable
      if (day.start != '' && day.end != '') {
        var start_time = day.start;
        var firstCharStart = start_time.split("");
        if (firstCharStart[0] == '0') {
          start_time = start_time.substring(1);
        }

        var end_time = day.end;
        var firstCharEnd = end_time.split("");
        if (firstCharEnd[0] == '0') {
          end_time = end_time.substring(1);
        }

        let dayData =
          <tr>
            <td>{day.day}</td>
            <td><i className="fas fa-clock mr-1"></i> {start_time} - {end_time}</td>
          </tr>

        timingClone.push(dayData);
      }
    })

    props.intrestedTeachers(item.demo_id)
      .then((res) => {
        setintrestedTeachers(res.data.result);
        debugger;
      })
      .catch((err) => {
        debugger;
      })

    settimingsArray(timingClone);
    setdisableDays(disableDaysClone);
  }

  const isDisabled = (date) => {
    const day = date.getDay(date);
    return disableDays.includes(day);
  }

  const scheduleDemoFunc = (e) => {
    console.log("Date", demoDate);
    console.log("Class Timing", afterLeadData);
    var year = demoDate.getFullYear();
    var month = demoDate.getMonth();
    var date = demoDate.getDate();
    var actualDate = `${year}/${+month + 1}/${date}`;
    props.submitDemoSchedule(studentId, props.loggedUserId, teacherId, courseId, phoneNumber, actualDate, demoTime)
      .then((res) => {
        debugger;
        if (res.data.status == "success") {
          console.log("intrested Teacher", res);
          $('#myModal').modal('toggle');
          setsnackbarMessage("Demo scheduled successfully");
          snackBarFunction();
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        }
      })
      .catch((err) => {

      })
  }

  const sendParentMessage = (leadId, studentId, courseId) => {
    debugger;
    props.statusQuestionData(studentId, props.loggedUserId, courseId, leadId, "initial_message", 2, 1)
      .then((res) => {
        debugger;
        if (res.data.status == "success") {
          $(`#exampleModal${leadId}`).modal('toggle');
          setsnackbarMessage("Message sent successfully");
          snackBarFunction();
        }
      })
      .catch((err) => {

      })
  }

  const sendConversionMessage = (leadId, studentId, courseId) => {
    debugger;
    props.statusQuestionData(studentId, props.loggedUserId, courseId, leadId, "conversion_message", 2, 1)
      .then((res) => {
        debugger;
        if (res.data.status == "success") {
          $(`#exampleModal${leadId}`).modal('toggle');
          setsnackbarMessage("Message sent successfully");
          snackBarFunction();
        }
      })
      .catch((err) => {

      })
  }

  const callPickedUp = (leadId, studentId, courseId) => {
    debugger;
    props.statusQuestionData(studentId, props.loggedUserId, courseId, leadId, "initial_call", 2, 1)
      .then((res) => {
        debugger;
        if (res.data.status == "success") {
          setsnackbarMessage("Picked up the call");
          snackBarFunction();
        }
      })
      .catch((err) => {

      })
  }
  const callDontPickedUp = (leadId, studentId, courseId) => {
    debugger;
    props.statusQuestionData(studentId, props.loggedUserId, courseId, leadId, "initial_call", 2, 0)
      .then((res) => {
        debugger;
        if (res.data.status == "success") {
          setsnackbarMessage("Did not pickup");
          snackBarFunction();
        }
      })
      .catch((err) => {

      })
  }
  const markSpammed = (leadId, studentId, courseId, spamStatus) => {
    debugger;
    $(`#exampleModal${leadId}`).modal('toggle');
    props.statusQuestionData(studentId, props.loggedUserId, courseId, leadId, "spam", 2, spamStatus)
      .then((res) => {
        debugger;
        if (res.data.status == "success") {
          if (spamStatus === 1) {
            setsnackbarMessage("Spammed Lead");
          }
          else {
            setsnackbarMessage("Not Spammed Lead");
          }
          snackBarFunction();
          // props
          //   .getLeadData(props.loggedUserId)
        }
      })
      .catch((err) => {

      })
  }
  const marknotIntrested = (leadId, studentId, courseId, intrestedStatus) => {
    debugger;
    $(`#exampleModal${leadId}`).modal('toggle');
    props.statusQuestionData(studentId, props.loggedUserId, courseId, leadId, "not_interested", 2, intrestedStatus)
      .then((res) => {
        debugger;
        if (res.data.status == "success") {
          if (intrestedStatus === 1) {
            setsnackbarMessage("Lead Not Intrested");
          }
          else {
            setsnackbarMessage("Lead Intrested");
          }
          snackBarFunction();
          // props
          //   .getLeadData(props.loggedUserId)
        }
      })
      .catch((err) => {

      })
  }
  const markNoResponse = (leadId, studentId, courseId, intrestedStatus) => {
    debugger;
    $(`#exampleModal${leadId}`).modal('toggle');
    props.statusQuestionData(studentId, props.loggedUserId, courseId, leadId, "no_response", 2, intrestedStatus)
      .then((res) => {
        debugger;
        if (res.data.status == "success") {
          if (intrestedStatus === 1) {
            setsnackbarMessage("No Reponse from Lead");
          }
          else {
            setsnackbarMessage("Response Received");
          }
          snackBarFunction();
          // props
          //   .getLeadData(props.loggedUserId)
        }
      })
      .catch((err) => {

      })
  }
  const cancelDemo = (leadId, studentId, courseId, intrestedStatus) => {
    debugger;
    $(`#exampleModal${leadId}`).modal('toggle');
    props.statusQuestionData(studentId, props.loggedUserId, courseId, leadId, "cancel_demo", 2, intrestedStatus)
      .then((res) => {
        debugger;
        if (res.data.status == "success") {
          if (intrestedStatus === 1) {
            setsnackbarMessage("Demo Cancelled");
          }
          else {
            setsnackbarMessage("Response Received");
          }
          snackBarFunction();
          // props
          //   .getLeadData(props.loggedUserId)
        }
      })
      .catch((err) => {

      })
  }
  const groupclassesImaggeSent = (leadId, studentId, courseId) => {
    debugger;
    $(`#exampleModal${leadId}`).modal('toggle');
    props.statusQuestionData(studentId, props.loggedUserId, courseId, leadId, "send_group_price", 2, 1)
      .then((res) => {
        debugger;
        if (res.data.status == "success") {
          setsnackbarMessage("Group Classes Price Sent");
          snackBarFunction();
        }
      })
      .catch((err) => {

      })
  }
  const videoTestimonialSend = (leadId, studentId, courseId, videoUrl, videoName) => {
    debugger;
    $(`#exampleModal${leadId}`).modal('toggle');
    props.statusQuestionData(studentId, props.loggedUserId, courseId, leadId, "testimonial_video", 2, 1, videoUrl, videoName)
      .then((res) => {
        debugger;
        if (res.data.status == "success") {
          setsnackbarMessage("Video Testimonial Send");
          snackBarFunction();
        }
      })
      .catch((err) => {

      })
  }

  const activityNotesSend = (leadId, studentId, courseId, videoUrl, videoName) => {
    debugger;
    // $(`#exampleModal${leadId}`).modal('toggle');
    props.statusQuestionData(studentId, props.loggedUserId, courseId, leadId, "activity_notes", 2, 1, videoUrl, videoName)
      .then((res) => {
        debugger;
        if (res.data.status == "success") {
          setsnackbarMessage("Notes Added");
          snackBarFunction();
          hitHistoryAPI(leadId);
        }
      })
      .catch((err) => {

      })
  }

  const influenceImageSend = (leadId, studentId, courseId, videoUrl) => {
    debugger;
    $(`#exampleModal${leadId}`).modal('toggle');
    props.statusQuestionData(studentId, props.loggedUserId, courseId, leadId, "influencer", 2, 1, videoUrl)
      .then((res) => {
        debugger;
        if (res.data.status == "success") {
          setsnackbarMessage("Influence Image Send");
          snackBarFunction();
        }
      })
      .catch((err) => {

      })
  }
  const curriculumImageSend = (leadId, studentId, courseId, videoUrl, videoName) => {
    debugger;
    $(`#exampleModal${leadId}`).modal('toggle');
    props.statusQuestionData(studentId, props.loggedUserId, courseId, leadId, "curriculum_img", 2, 1, videoUrl, videoName)
      .then((res) => {
        debugger;
        if (res.data.status == "success") {
          setsnackbarMessage(`${videoName} Image Sent`);
          snackBarFunction();
        }
      })
      .catch((err) => {

      })
  }
  const oneOnOneclassesImaggeSent = (leadId, studentId, courseId) => {
    debugger;
    $(`#exampleModal${leadId}`).modal('toggle');
    props.statusQuestionData(studentId, props.loggedUserId, courseId, leadId, "send_oneonone_price", 2, 1)
      .then((res) => {
        debugger;
        if (res.data.status == "success") {
          setsnackbarMessage("1 on 1 Classes Price Sent");
          snackBarFunction();
        }
      })
      .catch((err) => {

      })
  }
  const aboutThisCourse = (leadId, studentId, courseId) => {
    debugger;
    // $(`#exampleModal${leadId}`).modal('toggle');
    props.statusQuestionData(studentId, props.loggedUserId, courseId, leadId, "about_course", 2, 1)
      .then((res) => {
        debugger;
        if (res.data.status == "success") {
          setsnackbarMessage("Course Details Sent");
          snackBarFunction();
        }
      })
      .catch((err) => {

      })
  }

  const onChangeInitialQuestionData = e => {
    setinitialQuestionsData({ ...initialQuestionsData, [e.target.name]: e.target.value })
  }
  const onChangeInitialQuestionDataChallenges = (id) => {
    debugger;
    initialQuestionsData.challengesFace.map((item) => {
      if (item.id == id && item.checked == false) {
        item.checked = true
      }
      else if (item.id == id && item.checked == true) {
        item.checked = false
      }
    }
    )
    setinitialQuestionsData({ ...initialQuestionsData })
  }
  const onChangeInitialQuestionDataIntrested = (id) => {
    debugger;
    initialQuestionsData.tutoringOption.map((item) => {
      if (item.id == id && item.checked == false) {
        item.checked = true
      }
      else if (item.id == id && item.checked == true) {
        item.checked = false
      }
    }
    )
    setinitialQuestionsData({ ...initialQuestionsData })
  }

  const onChangeNotConvertingQuestion = (id) => {
    debugger;
    notConvertingQuestion.map((item) => {
      if (item.id == id && item.checked == false) {
        item.checked = true
      }
      else if (item.id == id && item.checked == true) {
        item.checked = false
      }
    }
    )
    setnotConvertingQuestion([...notConvertingQuestion]);
  }

  const submitPersonalData = (leadId) => {
    var data = {
      ...initialQuestionsData,
      notConvertingQuestion
    }
    props.personalQuestionData(leadId, JSON.stringify(data))
      .then((res) => {
        debugger;
        if (res.data.status == "success") {
          setsnackbarMessage("Data added");
          snackBarFunction();
        }
      })
      .catch((err) => {

      })
  }

  const hitHistoryAPIAndActiveTab = (leadId) => {
    setactiveTab(`wip${leadId}`);
    setpersonalQuestion("");
    setnotConvertingQuestion([
      {
        id: 1,
        title: 'Scheduling conflict',
        checked: false,
      },
      {
        id: 2,
        title: 'Pricing',
        checked: false,
      },
      {
        id: 3,
        title: 'Too burdensome for my child',
        checked: false,
      },
      {
        id: 4,
        title: 'Payment mechanism',
        checked: false,
      },
      {
        id: 5,
        title: "I didn't like the teacher",
        checked: false,
      },
      {
        id: 6,
        title: "Not now, maybe later",
        checked: false,
      },
      {
        id: 7,
        title: "Don't have the right technology or internet connection",
        checked: false,
      },
      {
        id: 8,
        title: "Signed up by mistake",
        checked: false,
      },
      {
        id: 9,
        title: "Not looking for tutoring at this time",
        checked: false,
      },
      {
        id: 10,
        title: "Already enrolled in other tutoring service",
        checked: false,
      },
      {
        id: 11,
        title: "Looking for physical classes, not online",
        checked: false,
      },
    ]);
    setinitialQuestionsData({
      parentName: '',
      whereLive: '',
      schoolName: '',
      challengesFace: [
        {
          id: 1,
          title: 'Weak concepts',
          checked: false,
        },
        {
          id: 2,
          title: 'Advance Learning',
          checked: false,
        },
        {
          id: 3,
          title: 'Homework help',
          checked: false,
        },
        {
          id: 4,
          title: 'Exam prep',
          checked: false,
        },
        {
          id: 5,
          title: 'Child has Learning Disability',
          checked: false,
        }
      ],
      tutoringOption: [
        {
          id: 1,
          title: 'Group classes',
          checked: false,
        },
        {
          id: 2,
          title: '1 on 1 classes',
          checked: false,
        },
        {
          id: 3,
          title: 'Exam prep classes',
          checked: false,
        },
        {
          id: 4,
          title: 'Homeschooling',
          checked: false,
        }
      ],
      notes: ''
    });
    props.getHistoryData(leadId)
      .then((res) => {
        sethistoryData(res.data);
        if (res.data.personal_info !== null) {
          debugger;
          setpersonalQuestion(JSON.parse(res.data.personal_info));
          var afterParse = JSON.parse(res.data.personal_info);
          debugger;
          if (typeof afterParse.tutoringOption == "string" || typeof afterParse.challengesFace == "string") {
            debugger;
            setinitialQuestionsData({
              ...afterParse, tutoringOption: [
                {
                  id: 1,
                  title: 'Group classes',
                  checked: false,
                },
                {
                  id: 2,
                  title: '1 on 1 classes',
                  checked: false,
                },
                {
                  id: 3,
                  title: 'Exam prep classes',
                  checked: false,
                },
                {
                  id: 4,
                  title: 'Homeschooling',
                  checked: false,
                }
              ],
              challengesFace: [
                {
                  id: 1,
                  title: 'Weak concepts',
                  checked: false,
                },
                {
                  id: 2,
                  title: 'Advance Learning',
                  checked: false,
                },
                {
                  id: 3,
                  title: 'Homework help',
                  checked: false,
                },
                {
                  id: 4,
                  title: 'Exam prep',
                  checked: false,
                },
                {
                  id: 5,
                  title: 'Child has Learning Disability',
                  checked: false,
                }
              ],

            });

          }
          else {
            debugger;
            setinitialQuestionsData({ ...afterParse });

          }
          // setinitialQuestionsData({ ...afterParse });
          setnotConvertingQuestion([...afterParse.notConvertingQuestion])
        }
      })
      .catch((err) => {
        debugger;
      })
  }
  const hitHistoryAPI = (leadId) => {
    setpersonalQuestion("");
    setnotConvertingQuestion([
      {
        id: 1,
        title: 'Scheduling conflict',
        checked: false,
      },
      {
        id: 2,
        title: 'Pricing',
        checked: false,
      },
      {
        id: 3,
        title: 'Too burdensome for my child',
        checked: false,
      },
      {
        id: 4,
        title: 'Payment mechanism',
        checked: false,
      },
      {
        id: 5,
        title: "I didn't like the teacher",
        checked: false,
      },
      {
        id: 6,
        title: "Not now, maybe later",
        checked: false,
      },
      {
        id: 7,
        title: "Don't have the right technology or internet connection",
        checked: false,
      },
      {
        id: 8,
        title: "Signed up by mistake",
        checked: false,
      },
      {
        id: 9,
        title: "Not looking for tutoring at this time",
        checked: false,
      },
      {
        id: 10,
        title: "Already enrolled in other tutoring service",
        checked: false,
      },
      {
        id: 11,
        title: "Looking for physical classes, not online",
        checked: false,
      },
    ]);
    setinitialQuestionsData({
      parentName: '',
      whereLive: '',
      schoolName: '',
      challengesFace: [
        {
          id: 1,
          title: 'Weak concepts',
          checked: false,
        },
        {
          id: 2,
          title: 'Advance Learning',
          checked: false,
        },
        {
          id: 3,
          title: 'Homework help',
          checked: false,
        },
        {
          id: 4,
          title: 'Exam prep',
          checked: false,
        },
        {
          id: 5,
          title: 'Child has Learning Disability',
          checked: false,
        }
      ],
      tutoringOption: [
        {
          id: 1,
          title: 'Group classes',
          checked: false,
        },
        {
          id: 2,
          title: '1 on 1 classes',
          checked: false,
        },
        {
          id: 3,
          title: 'Exam prep classes',
          checked: false,
        },
        {
          id: 4,
          title: 'Homeschooling',
          checked: false,
        }
      ],
      notes: ''
    });
    props.getHistoryData(leadId)
      .then((res) => {
        sethistoryData(res.data);
        if (res.data.personal_info !== null) {
          debugger;
          setpersonalQuestion(JSON.parse(res.data.personal_info));
          var afterParse = JSON.parse(res.data.personal_info);
          debugger;
          if (typeof afterParse.tutoringOption == "string" || typeof afterParse.challengesFace == "string") {
            debugger;
            setinitialQuestionsData({
              ...afterParse, tutoringOption: [
                {
                  id: 1,
                  title: 'Group classes',
                  checked: false,
                },
                {
                  id: 2,
                  title: '1 on 1 classes',
                  checked: false,
                },
                {
                  id: 3,
                  title: 'Exam prep classes',
                  checked: false,
                },
                {
                  id: 4,
                  title: 'Homeschooling',
                  checked: false,
                }
              ],
              challengesFace: [
                {
                  id: 1,
                  title: 'Weak concepts',
                  checked: false,
                },
                {
                  id: 2,
                  title: 'Advance Learning',
                  checked: false,
                },
                {
                  id: 3,
                  title: 'Homework help',
                  checked: false,
                },
                {
                  id: 4,
                  title: 'Exam prep',
                  checked: false,
                },
                {
                  id: 5,
                  title: 'Child has Learning Disability',
                  checked: false,
                }
              ],

            });

          }
          else {
            debugger;
            setinitialQuestionsData({ ...afterParse });

          }
          // setinitialQuestionsData({ ...afterParse });
          setnotConvertingQuestion([...afterParse.notConvertingQuestion])
        }
      })
      .catch((err) => {
        debugger;
      })
  }

  const SendMessageToAllTutorsFunc = () => {
    var dateForTutors = moment(demoDateForTeacher).format("YYYY-MM-DD HH:mm");
    props.SendMessageToAllTutors(courseId, programId, selectedEmId, selectedLeadId, dateForTutors)
      .then((res) => {
        setsnackbarMessage("Request Sent to all Tutors");
        snackBarFunction();
        $(`#myModal`).modal('toggle');

      })
  }

  const applyFilter = (keyword, status) => {
    setfilterLoading(true);
    setselectedStatus(status);
    setkeyWord(keyWord);
    window.localStorage.setItem("searchStudent" , "");
    getLeadDataFilter(loggedUserId, status, keyword)
      .then((res) => {
        setfilterLoading(false);
        debugger;
      })
  }

  const submitNotConverting = () => {
    debugger;
    var data = {
      ...initialQuestionsData,
      notConvertingQuestion
    }
    console.log("Submit Data", data);

  }

  const gradeClicked = (e) => {
    if (e !== "") {
      setselectedGrade(e.target.value);
      // this.setState({
      //     showSubjectDropdown: true,
      //     selectedGrade: e.target.value
      // })
    }
    else {
      setselectedGrade(e.target.value);
      // this.setState({
      //     showSubjectDropdown: false,
      //     selectedGrade: e.target.value
      // })
    }
  }

  const sendUserNameFunc = (e, item) => {
    console.log("ITEMS", item);
    var LoginData = JSON.parse(localStorage.getItem("loginData"));
    props.SendUserName(item.user_id, LoginData.user.id, item.demo_id, e.target.value)
      .then((res) => {
        debugger;
      })
      .catch((err) => {

      })
    setaddUserName(e.target.value);

  }

  const onTimeTableSelectModal = (timeData, teacherInfo, students) => {
    console.log("Timings List", timeData);
    console.log("Teacher Info", teacherInfo);
    setteacherId(teacherInfo[0]['teacherid']);
    const timingClone = [];
    const disableDaysClone = [];
    setselectedTimeTable(timeData);
    Object.keys(timeData).map((id, key) => {
      var day = timeData[id];

      //making logic for disable Days
      if (day.day.includes("Sunday") && day.is_on) {
        disableDaysClone.push(0)
      }
      else if (day.day.includes("Monday") && day.is_on) {
        disableDaysClone.push(1)
      }
      else if (day.day.includes("Tuesday") && day.is_on) {
        disableDaysClone.push(2)
      }
      else if (day.day.includes("Wednesday") && day.is_on) {
        disableDaysClone.push(3)
      }
      else if (day.day.includes("Thursday") && day.is_on) {
        disableDaysClone.push(4)
      }
      else if (day.day.includes("Friday") && day.is_on) {
        disableDaysClone.push(5)
      }
      else if (day.day.includes("Saturday") && day.is_on) {
        disableDaysClone.push(6)
      }

      //Logic for timetable
      if (day.start != '' && day.end != '') {
        var start_time = day.start;
        var firstCharStart = start_time.split("");
        if (firstCharStart[0] == '0') {
          start_time = start_time.substring(1);
        }

        var end_time = day.end;
        var firstCharEnd = end_time.split("");
        if (firstCharEnd[0] == '0') {
          end_time = end_time.substring(1);
        }

        let dayData =
          <tr>
            <td>{day.day_date}</td>
            <td><i className="fas fa-clock mr-1"></i> {start_time} - {end_time}</td>
            <td><i className="fas fa-user mr-1"></i><span className="text-success font-weight-bold"> {students} </span>{day.demo_students != 0 ? <React.Fragment> + <span style={{ color: '#e75480' }} className="font-weight-bold"> {day.demo_students} </span></React.Fragment> : null}</td>
          </tr>

        timingClone.push(dayData);
      }
    })

    settimingsArray(timingClone);
    setdisableDays(disableDaysClone);
  }

  const confirmTutor = () => {
    props.confirmTutor(courseId, selectedEmId, teacherIdInterest, classRequestId)
      .then((res) => {
        debugger;
        window.location.reload();
      })
      .catch((err) => {
        debugger;
      })
  }

  const onchangeTeacher = (e) => {
    var data = JSON.parse(e.target.value);
    console.log(data);
    setteacherIdInterest(data.teacher_id);
    setclassRequestId(data.class_request_id);
  }

  console.log("After Leads Data", afterLeadData);
  // console.log("Initial Question Data", initialQuestionsData);
  // console.log("Not Converting Question Data", notConvertingQuestion);

  console.log("Demo Date For Teacher", moment(demoDateForTeacher).format("YYYY-MM-DD HH:mm"));
  return (
    <div className="mt-5 tableMobileView">
      <Snackbar msg={snackbarMessage} color={snackbarColor} />



      <SearchSection availableDemoStatus={availableDemoStatus} applyFilter={applyFilter} filterLoading={filterLoading} />

      <div className="modal fade" tabIndex="-1" role="dialog" id="myModal">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{programName}</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              {/* <div className="row">
                <div className="col-md-3 col-4">
                  <div className="">
                    <img src={`${tutotImage}`} className="img-thumbnail" alt="Tutor Image" />
                  </div>
                </div>
                <div className="col-md-9 col-4">
                  <label className="font-weight-bold">Taught by:</label>&nbsp;
                  <label>{tutorName}</label><br />
                  <label className="font-weight-bold"># of students: </label> <br />
                  <label>Time Slot:</label>
                </div>
              </div>
              <table className="table table-sm">
                <tbody>
                  {timingsArray}
                </tbody>
              </table> */}
              <div className="row">
                {/* <div className="col-md-12">
                  <label className="font-weight-bold">Schedule a demo class:</label>
                </div>
                <div className="col-md-6">
                  <DatePicker
                    selected={demoDate}
                    onChange={(date) => onDateChange(date)}
                    filterDate={isDisabled}
                    placeholderText="Select Date"
                    minDate={new Date()}
                  // value={demoDate}
                  />
                </div>
                {demoDate !== "" ?
                  <div className="col-md-6 text-right">
                    <button className="scheduleBtn" onClick={scheduleDemoFunc}>Submit</button>
                  </div>
                  :
                  null} */}


                <div className="col-md-12 text-center">
                  <label className="font-weight-bold">Available timings</label>
                </div>
                <div className="col-md-12">
                  <div id="accordionGroup" className="accordionForTimeTables">

                    {timingsTeachers && timingsTeachers.map((item, index) =>
                      item.teachers_info && item.teachers_info ?
                        <div class="card mt-3">
                          <div onClick={() => onTimeTableSelectModal(JSON.parse(item.Timing), JSON.parse(item.teachers_info), item.students)} className="backgroundForAnotherClass d-flex justify-content-between collapsed" data-toggle="collapse" data-target={`#collapse${index}`}>
                            <div>
                              <img src={JSON.parse(item.teachers_info)[0]['img_src']} className="" alt="TI" />
                              <label className="text-light ml-2">{item.teachers_info && JSON.parse(item.teachers_info)[0]['name'].slice(0, 8) + (JSON.parse(item.teachers_info)[0]['name'].length > 8 ? ".." : "")}</label>
                            </div>
                            <div>
                              <label className="mt-1" style={{ color: "#FBDE00" }}><i className="fas fa-user mr-1"></i> {item.students}</label>
                            </div>
                            <div>
                              <label className="text-light mr-2 mt-1">{JSON.parse(item.Timing)[1]['start']} - {JSON.parse(item.Timing)[1]['end']} <i className="fas fa-chevron-down ml-2 text-light"></i></label>
                            </div>
                          </div>

                          <div id={`collapse${index}`} class="collapse" aria-labelledby="headingOne" data-parent="#accordionGroup">
                            <div class="card-body">
                              <table className="table table-sm">
                                <tbody>
                                  {timingsArray}
                                </tbody>
                              </table>
                              <div className="row">
                                <div className="col-md-12">
                                  <label className="font-weight-bold">Schedule a demo class:</label>
                                </div>
                                <div className="col-md-6">
                                  <DatePicker
                                    selected={demoDate}
                                    onChange={(date) => onDateChange(date)}
                                    filterDate={isDisabled}
                                    placeholderText="Select Date"
                                    minDate={new Date()}
                                  // value={demoDate}
                                  />
                                </div>
                                {demoDate !== "" ?
                                  <div className="col-md-6 text-right">
                                    <button className="btn btn-success btn-sm" onClick={scheduleDemoFunc}>Schedule Demo</button>
                                  </div>
                                  :
                                  null}
                              </div>
                            </div>
                          </div>
                        </div>
                        : null

                    )}

                    <div class="card mt-3">
                      <div className="backgroundForOneonOneClass d-flex justify-content-between collapsed" data-toggle="collapse" data-target={`#collapseOne`}>
                        <div className="text-center">
                          <label className="text-dark font-weight-bold">Schedule Demo for 1 on 1 class</label>
                        </div>
                        <div>
                          {/* <label className="text-light mr-2 mt-1">{JSON.parse(item.Timing)[1]['start']} - {JSON.parse(item.Timing)[1]['end']}</label> */}
                          <i className="fas fa-chevron-down ml-2 text-light"></i>
                        </div>
                        {/* <div>
                              <label className="text-light mt-1">- Students</label>
                            </div> */}
                      </div>

                      <div id={`collapseOne`} class="collapse" aria-labelledby="headingOne" data-parent="#accordionGroup">
                        <div class="card-body">
                          {intrestedTeachers.length <= 0 ?
                            <div className="row text-center">
                              <div className="col-md-12">
                                <label className="font-weight-bold">Select date and time for the demo class:</label>
                              </div>
                              <div className="col-md-12">
                                <DatePicker
                                  selected={demoDateForTeacher}
                                  onChange={(date) => setdemoDateForTeacher(date)}
                                  // filterDate={isDisabled}
                                  placeholderText="Select Date"
                                  minDate={new Date()}
                                  showTimeSelect
                                  timeIntervals={15}
                                  timeCaption="time"
                                  dateFormat="MMMM d, yyyy h:mm aa"
                                  value={demoDateForTeacher}
                                />
                              </div>

                              <div className="col-md-12 mt-2 text-center mt-5">
                                <button className="btn btn-success btn-block" onClick={() => SendMessageToAllTutorsFunc()}>Send message to all Tutors</button>
                              </div>

                            </div>
                            :
                            <div className="row text-center">
                              <div className="col-md-12">
                                <label className="font-weight-bold">Intrested Teachers for this demo class:</label>
                              </div>
                              <div className="col-md-12">
                                <select className="form-control" onChange={(e) => onchangeTeacher(e)}>
                                  <option>Select Tutor</option>
                                  {intrestedTeachers.map((item, index) =>
                                    <option key={index} value={JSON.stringify(item)}>{item.user_name}</option>
                                  )}
                                </select>
                              </div>

                              <div className="col-md-12 mt-2 text-center mt-5">
                                <button className="btn btn-success btn-block" onClick={() => confirmTutor()}>Add tutor for this demo class</button>
                              </div>

                            </div>}
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

                {/* <div className="col-md-12">
                  <div className="backgroundForCustomise">
                    <label>None of these times works for the parent</label>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" tabIndex="-1" role="dialog" id="changeCourseModal">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">Change the course</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                {/* <div className="col-md-12 text-center">
                  <label className="labelForChangeCourse"><i className="fas fa-chalkboard-teacher mr-2"></i>Change the course of the lead from here</label>
                </div> */}
                <div className="col-md-12 text-center">
                  {/* <hr /> */}
                  <button className={selecteCourseTab === 1 ? "changeKGSBtnActive" : "changeKGSBtn"} onClick={() => setselecteCourseTab(1)}>Courses for KGS</button>

                  <button className={selecteCourseTab !== 1 ? "allCourseBtnActive" : "allCourseBtn"} onClick={() => setselecteCourseTab(2)}>All Courses</button>
                </div>

                {selecteCourseTab === 1 ?
                  <React.Fragment>

                    <div className="col-md-12 mt-4">
                      <div class="form-group">
                        <label className="font-weight-bold" style={{ fontSize: 14 }} for="exampleFormControlSelect1">Select Subject</label>
                        <select
                          class="form-control form-control-sm"
                          onChange={(e) => onChangeSubbjectForKGS(e)}
                        >
                          <option value="">
                            Select a Subject
                          </option>
                          <option value="Nursery KGS admission prep">Nursery KGS admission prep</option>
                          <option value="Grade 3 KGS admission prep">Grade 3 KGS admission prep</option>
                          <option value="Grade 7 KGS admission prep">Grade 7 KGS admission prep</option>
                          <option value="Grade 10 KGS admission prep">Grade 10 KGS admission prep</option>
                        </select>
                      </div>
                    </div>

                    <div className="col-md-12 text-right mt-4">
                      <button onClick={() => changeCourseFuncForKGS()} className={selectedGrade == "" ? "btn btn-success" : "btn btn-success"} disabled={selectedGrade == "" ? true : false}>Change Course</button>
                    </div>
                  </React.Fragment>
                  :
                  <React.Fragment>
                    <div className="col-md-12 mt-4">
                      <div class="form-group">
                        <label style={{ fontSize: 14 }}>Select Grade</label>
                        <select class="form-control form-control-sm" id="exampleFormControlSelect1" onChange={(e) => gradeClicked(e)}>
                          <option value="">Select a Grade</option>
                          {grades && grades.map((item, index) =>
                            <option value={item} >{item}</option>
                          )}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div class="form-group">
                        <label style={{ fontSize: 14 }} for="exampleFormControlSelect1">Select Subject</label>
                        <select
                          class="form-control form-control-sm"
                          onChange={(e) => setcourseName(e.target.value)}
                        >
                          <option value="">
                            Select a Subject
                      </option>
                          {selectedGrade !== "" ?
                            <React.Fragment>
                              <option value="English">English</option>
                              <option value="Math">Math</option>
                            </React.Fragment>
                            :
                            null
                          }
                          {
                            selectedGrade == "Grade 2" ||
                              selectedGrade == "Grade 3" ||
                              selectedGrade == "Grade 4" ||
                              selectedGrade == "Grade 5" ||
                              selectedGrade == "Grade 6" ||
                              selectedGrade == "Grade 7" ||
                              selectedGrade == "Grade 8" ||
                              selectedGrade == "Grade 9" ?
                              <option value="Creative Writing">Creative Writing</option>
                              : null
                          }

                          {/* {
                                        selectedGrade == "Grade 9" ||
                                            selectedGrade == "Grade 10" ?
                                            <option value="Chemistry">Chemistry</option>

                                            : null

                                    } */}

                          {
                            selectedGrade == "Kindergarten" ||
                              selectedGrade == "Grade 1" ||
                              selectedGrade == "Grade 2" ||
                              selectedGrade == "Grade 3" ||
                              selectedGrade == "Grade 4" ||
                              selectedGrade == "Grade 5" ||
                              selectedGrade == "Grade 6" ||
                              selectedGrade == "Grade 7" ||
                              selectedGrade == "Grade 8" ?
                              <option value="Science">Science</option> : null
                          }


                        </select>
                      </div>
                    </div>
                    <div className="col-md-12 text-right mt-4">
                      <button onClick={() => changeCourseFunc()} className={courseName == "" ? "btn btn-success" : "btn btn-success"} disabled={courseName == "" ? true : false}>Change Course</button>
                    </div>
                  </React.Fragment>
                }

              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="body" className="table-responsive">
        <table className="table">
          <thead className="tableHeader">
            <tr className="d-flex">
              <th className="col-1">#</th>
              <th className="col-4">Program</th>
              <th className="col-3">Student Name</th>
              <th className="col-1">Signup</th>
              <th className="col-2">Ownership</th>
              <th className="col-1">Status</th>
            </tr>
          </thead>
          <tbody>
            {afterLeadData.map((item, index) => (
              <React.Fragment key={index}>
                <tr className="d-flex">
                  <td className="col-1 text-center">{item.demo_id}  <div className="waitingListIndicator">
                    {item.waiting_list === 1 ?
                      <label>WL</label>
                      : null
                    }
                  </div></td>
                  <td className="col-4">
                    <div>
                      {item.program}
                      <span className="text-info ml-1" style={{ fontSize: 12, cursor: 'pointer' }} data-toggle="modal" data-target="#changeCourseModal" onClick={() => courseModalData(item)} >Change Course</span>
                      <br />
                      {item.ownership == "mine" ? (
                        <div className="mt-1 infoFont">
                          <label className="text-muted">Taught by {typeof item.teachers_info[0] !== "undefined" && item.teachers_info[0]['name']}</label>
                          <br />
                          <i className="far fa-clock mr-1"></i>
                          <label className="text-muted">{item.timing['1']['start'] + " - " + item.timing['1']['end']}</label>
                          <label style={{ cursor: 'pointer', color: "#17a2b8" }} className="ml-1" data-toggle="modal" data-target="#myModal" onClick={() => modalData(item)}>(Schedule Demo)</label>
                          <br />
                          {item.is_scheduled_demo === 1 ?
                            <label className="font-weight-bold text-primary">*Demo class scheduled on {validateDate(item.scheduled_date_time)} {validateMonth(item.scheduled_date_time)} {new Date(item.scheduled_date_time).getFullYear()} {new Date(item.scheduled_date_time).toLocaleTimeString('en-US').replace(/:\d+ /, ' ')}</label>
                            : null}
                          {item.is_scheduled_demo === 2 ?
                            <label style={{ color: "#42b72a", fontWeight: "bold" }}>*Demo conducted successfully</label>
                            : null}
                          {item.is_scheduled_demo === 3 ?
                            <label style={{ color: "#ff3823", fontWeight: "bold" }}>*Student was absent in the demo class</label>
                            : null}

                          <div style={{ background: "#efefef", position: 'relative', bottom: -12 }}>
                            <label
                              data-toggle="collapse"
                              data-target={`#one${item.demo_id}`}
                              aria-expanded="false"
                              aria-controls="1" className="text-dark font-weight-bold ml-2"
                              style={{ cursor: "pointer" }}
                              // onClick={() => setactiveTab(`wip${item.demo_id}`)}
                              onClick={() => hitHistoryAPIAndActiveTab(item.demo_id)}
                            >
                              See Details <i className="fas fa-chevron-down mt-1"></i>
                            </label>
                          </div>
                        </div>
                      )
                        :
                        (
                          <div className="mt-1 infoFont">
                            <label className="text-muted">Taught by {typeof item.teachers_info[0] !== "undefined" && item.teachers_info[0]['name']}</label>
                            <br />
                            <i className="far fa-clock mr-1"></i>
                            <label className="text-muted">{item.timing['1']['start'] + " - " + item.timing['1']['end']}</label>
                            <br />
                            {item.is_scheduled_demo === 1 ?
                              <label className="font-weight-bold text-primary">*Demo class scheduled on {validateDate(item.scheduled_date_time)} {validateMonth(item.scheduled_date_time)} {new Date(item.scheduled_date_time).getFullYear()} {new Date(item.scheduled_date_time).toLocaleTimeString('en-US').replace(/:\d+ /, ' ')}</label>
                              : null}
                            {item.is_scheduled_demo === 2 ?
                              <label style={{ color: "#42b72a", fontWeight: "bold" }}>*Demo conducted successfully</label>
                              : null}
                            {item.is_scheduled_demo === 3 ?
                              <label style={{ color: "#ff3823", fontWeight: "bold" }}>*Student was absent in the demo class</label>
                              : null}

                            <div style={{ background: "#efefef", position: 'relative', bottom: -12 }}>
                              <label
                                data-toggle="collapse"
                                data-target={`#one${item.demo_id}`}
                                aria-expanded="false"
                                aria-controls="1" className="text-dark font-weight-bold ml-2"
                                style={{ cursor: "pointer" }}
                                // onClick={() => setactiveTab(`wip${item.demo_id}`)}
                                onClick={() => hitHistoryAPIAndActiveTab(item.demo_id)}
                              >
                                See Details <i className="fas fa-chevron-down mt-1"></i>
                              </label>
                            </div>
                          </div>
                        )
                      }
                    </div>

                  </td>
                  <td className="col-3">
                    {item.ownership == "mine" ? (
                      <div>
                        {item.studentName == "" ? <input type="text" onBlur={(e) => sendUserNameFunc(e, item)} className="form-control form-control-sm" placeholder="Add Student Name" /> : item.studentName}
                        {/* {item.studentName} */}
                        <br />
                        {item.ParentName !== "" ? <label>Parent Name: <span className="text-info font-weight-bold"> {item.ParentName} </span></label> : null}
                        <div>
                          <label
                            style={{ color: "#42b72a", cursor: "pointer" }}
                            className="font-weight-bold phoneNumberSize d-flex"
                          >
                            <i className="fas fa-mobile-alt mr-1 mt-1"></i>
                            <a className="" style={{ color: "#42b72a", cursor: "pointer" }} href={`tel:+${item.phoneNumber}`}>+{item.phoneNumber}</a>
                          </label>
                        </div>
                        <div>
                          <label
                            style={{ color: "#42b72a", cursor: "pointer" }}
                            className="font-weight-bold phoneNumberSize d-flex"
                          >
                            <i className="fab fa-whatsapp mr-1 mt-1"></i>
                            <a className="linkShow" style={{ color: "#42b72a", cursor: "pointer" }} target="_blank" href={`https://api.whatsapp.com/send?phone=${item.phoneNumber}`}>Chat on WhatsApp</a>
                          </label>
                        </div>
                        {item.web_identifier && <label>From <span className="text-info font-weight-bold"> {item.web_identifier} {item.referrer && item.referrer.substring(1)} </span> domain.</label>}
                      </div>
                    ) : (
                        <div>
                          {item.studentName == "" ? <input type="text" className="form-control form-control-sm" placeholder="Add Student Name" onBlur={(e) => sendUserNameFunc(e, item)} /> : item.studentName}
                          <br />
                          {item.ParentName !== "" ? <label>Parent Name: <span className="text-info font-weight-bold"> {item.ParentName} </span></label> : null}
                          <div>
                            <label
                              style={{ color: "#42b72a", cursor: "pointer" }}
                              className="font-weight-bold phoneNumberSize d-flex"
                            >
                              <i className="fas fa-mobile-alt mr-1 mt-1"></i>
                              <a className="" style={{ color: "#42b72a", cursor: "pointer" }} href={`tel:+${item.phoneNumber}`}>+{item.phoneNumber}</a>
                            </label>
                          </div>
                          <div>
                            <label
                              style={{ color: "#42b72a", cursor: "pointer" }}
                              className="font-weight-bold phoneNumberSize d-flex"
                            >
                              <i className="fab fa-whatsapp mr-1 mt-1"></i>
                              <a className="" style={{ color: "#42b72a", cursor: "pointer" }} target="_blank" href={`https://api.whatsapp.com/send?phone=${item.phoneNumber}`}>Chat on WhatsApp</a>
                            </label>
                          </div>
                          {item.web_identifier && <label>From <span className="text-info font-weight-bold"> {item.web_identifier} {item.referrer && item.referrer.substring(1)} </span> domain.</label>}
                        </div>
                      )}
                  </td>
                  <td className="col-1">
                    {/* <div class="form-check"> */}
                    {/* <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="defaultCheck1"
                    /> */}
                    <label className="text-center">
                      {item.date} {item.demo} <br />
                      <span style={{ fontSize: 12 }}> {item.time} </span>
                    </label>
                    {/* </div> */}
                  </td>
                  <td className="col-2">
                    {item.ownership === "mine" ? (
                      <div style={{ color: "#FFA834" }}>
                        <label className="font-weight-bold">Mine</label>
                        {/* <i
                          className="fas fa-plus-circle mineIconPlus"
                          style={{ fontSize: 22 }}
                          data-toggle="collapse"
                          data-target={`#one${item.demo_id}`}
                          aria-expanded="false"
                          aria-controls="1"
                        ></i>*/}

                        {/* <button
                          class="withDrawIt"
                          onClick={() =>
                            WithdrawIt(item.demo_id, item.user_id, item.course_id)
                          }
                        >
                          Withdraw
                      </button> */}
                      </div>
                    ) : item.ownership === "available" ? (
                      <button
                        className="btnOwnIt"
                        onClick={() => OwnIt(item.demo_id)}
                      >
                        Own it
                      </button>
                    ) : item.ownership === "taken" ? (
                      item.emPicture !== "" ? (
                        <label className="">
                          <img
                            src={item.emPicture}
                            alt="Avatar"
                            className="avatar avatarMargin"
                          />
                          <br />
                          <label style={{ color: "#D7385E", fontWeight: "bold" }}>
                            {item.emName}
                          </label>
                        </label>
                      ) : (
                          <label className="">
                            <img
                              src="https://ctt.trains.com/sitefiles/images/no-preview-available.png"
                              alt="Avatar"
                              className="avatar avatarMargin"
                            />
                            <br />
                            <label style={{ color: "#D7385E", fontWeight: "bold" }}>
                              {item.emName}
                            </label>
                          </label>
                        )
                    ) : item.ownership === "converted" ? (
                      <label className="text-success text-center" style={{ fontWeight: "bold" }}>
                        Converted <i style={{ fontSize: 22 }} className="far fa-smile" />
                      </label>
                    ) : ""}
                    <br />
                  </td>

                  {item.demo_status === 1 ?
                    <td className="col-1 stepColumn">
                      <span>1</span><br /><label> Signup </label>
                    </td>
                    : item.demo_status === 2 && item.spam === 0 && item.not_interested === 0 && item.no_response === 0 ?
                      <td className="col-1 stepColumn">
                        <span>2</span><br /><label> Initial Call </label>
                      </td>

                      : item.spam === 1 && item.not_interested === 0 ?
                        <td className="col-1 stepColumn">
                          <label className="font-weight-bold"> Spam Call </label>
                        </td>
                        : item.spam === 0 && item.not_interested === 1 ?
                          <td className="col-1 stepColumn">
                            <label className="font-weight-bold"> Not Interested </label>
                          </td>
                          : item.spam === 0 && item.not_interested === 0 && item.no_response === 1 ?
                            <td className="col-1 stepColumn">
                              <label className="font-weight-bold"> No Response </label>
                            </td>
                            : item.demo_status === 3 && item.spam === 0 && item.not_interested === 0 ?
                              <td className="col-1 stepColumn">
                                <span>3</span><br /><label> Demo Scheduled </label>
                              </td>
                              : item.demo_status === 4 ?
                                <td className="col-1 stepColumn">
                                  <span>4</span><br /><label> Demo Conducted </label>
                                </td>
                                : null
                  }
                </tr>

                <div className="collapse" id={`one${item.demo_id}`}>
                  <div
                    className="card card-body"
                    style={{ backgroundColor: "#efefef", borderRadius: 0, borderTop: "none" }}
                  >
                    {typeof faqData[item.demo_id] == "undefined" && item.ownership === "mine" ? <div className="row">
                      <div className="col-md-12 text-right">
                        <button
                          className="withDrawIt"
                          onClick={() =>
                            WithdrawIt(item.demo_id, item.user_id, item.course_id)
                          }
                          data-toggle="collapse"
                          data-target={`#one${item.demo_id}`}
                        >
                          Remove Me <i className="fas fa-times"></i>
                        </button>
                      </div>
                    </div> : null}

                    <div className="row">
                      <div className="col-md-12">

                        <Nav tabs className="questionsTab">
                          <NavItem>
                            <NavLink
                              active={activeTab == `wip${item.demo_id}`}
                              className="tabsNavlink"
                              onClick={() => setactiveTab(`wip${item.demo_id}`)}
                            >
                              Work in progress
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              active={activeTab == `history${item.demo_id}`}
                              className="tabsNavlink"
                              onClick={() => setactiveTab(`history${item.demo_id}`)}
                            // onClick={() => hitHistoryAPIAndActiveTab(item.demo_id)}
                            >
                              History
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              active={activeTab == `history${item.demo_id}`}
                              className="tabsNavlink"
                              onClick={() => setactiveTab(`history${item.demo_id}`)}
                            // onClick={() => hitHistoryAPIAndActiveTab(item.demo_id)}
                            >
                              Billing
                            </NavLink>
                          </NavItem>
                        </Nav>
                        <TabContent activeTab={activeTab}>
                          <TabPane tabId={`wip${item.demo_id}`}>

                            <StatusQuestion aboutThisCourse={aboutThisCourse} historyData={historyData} leadId={item.demo_id} programName={item.program} studentName={item.studentName} sendParentMessage={sendParentMessage} key={index} studentId={item.user_id} courseId={item.course_id} callPickedUp={callPickedUp} callDontPickedUp={callDontPickedUp} cancelDemo={cancelDemo} markNoResponse={markNoResponse} markSpammed={markSpammed} marknotIntrested={marknotIntrested} groupclassesImaggeSent={groupclassesImaggeSent} oneOnOneclassesImaggeSent={oneOnOneclassesImaggeSent} initialQuestionsData={initialQuestionsData} onChangeInitialQuestionData={onChangeInitialQuestionData} submitPersonalData={submitPersonalData} spam={item.spam} notInterested={item.not_interested} noResponse={item.no_response} onChangeInitialQuestionDataChallenges={onChangeInitialQuestionDataChallenges} onChangeInitialQuestionDataIntrested={onChangeInitialQuestionDataIntrested} videoTestimonialSend={videoTestimonialSend} influenceImageSend={influenceImageSend} notConvertingQuestion={notConvertingQuestion} onChangeNotConvertingQuestion={onChangeNotConvertingQuestion} curriculum_img={item.curriculum_img} curriculumImageSend={curriculumImageSend} submitNotConverting={submitNotConverting} sendConversionMessage={sendConversionMessage} />

                          </TabPane>
                          <TabPane tabId={`history${item.demo_id}`}>
                            <HistoryTab studentId={item.user_id} activityNotesSend={activityNotesSend} leadId={item.demo_id} personalQuestion={personalQuestion} historyData={historyData} courseId={item.course_id} />
                          </TabPane>
                        </TabContent>
                      </div>
                    </div>
                    {/* <fieldset
                      disabled={
                        typeof faqData[item.demo_id] == "undefined" ? false : true
                      }
                    >
                      <div className="row">
                        <div className="col-md-12">
                          <label style={{ fontSize: 30 }}>FAQ's</label>
                        </div>
                        <div className="col-md-6">

                          <label>Does the client want to pay and continue?</label>
                        </div>
                        <div className="col-md-6">
                          <button
                            type="button"
                            className={
                              typeof tempData[item.demo_id] !== "undefined" &&
                                JSON.parse(tempData[item.demo_id])[0].sel_opt ==
                                "Yes"
                                ? "btnForYesSelected"
                                : "btnForYes"
                            }
                            value="Yes"
                            title="Do you want to pay and continue?"
                            onClick={(e) => newChangeQuestion(e, item.demo_id)}
                          >
                            Yes
                        </button>
                          <button
                            type="button"
                            className={
                              typeof tempData[item.demo_id] !== "undefined" &&
                                JSON.parse(tempData[item.demo_id])[0].sel_opt ==
                                "No"
                                ? "btnForNoSelected"
                                : "btnForNo"
                            }
                            value="No"
                            title="Do you want to pay and continue?"
                            onClick={(e) => newChangeQuestion(e, item.demo_id)}
                          >
                            No
                        </button>
                        </div>
                      </div>
                      {typeof tempData[item.demo_id] !== "undefined" &&
                        JSON.parse(tempData[item.demo_id])[0].sel_opt == "Yes" ? (
                          <div className="transForExpand">
                            <hr className="hrLine" />
                            <div className="row">
                              <div className="col-md-4">
                                <label>Preferred payment type?</label>
                              </div>
                              <div className="col-md-8">
                                <button
                                  type="button"
                                  className={
                                    typeof tempData[item.demo_id] !== "undefined" &&
                                      JSON.parse(tempData[item.demo_id])[1].sel_opt ==
                                      "Jazz"
                                      ? "btnForYesSelected"
                                      : "btnForYes"
                                  }
                                  value="Jazz"
                                  title="Preferred payment type?"
                                  onClick={(e) =>
                                    newChangeQuestion(e, item.demo_id)
                                  }
                                >
                                  Jazz
                            </button>
                                <button
                                  type="button"
                                  className={
                                    typeof tempData[item.demo_id] !== "undefined" &&
                                      JSON.parse(tempData[item.demo_id])[1].sel_opt ==
                                      "Debit/Credit"
                                      ? "btnForYesSelected"
                                      : "btnForYes"
                                  }
                                  value="Debit/Credit"
                                  title="Preferred payment type?"
                                  onClick={(e) =>
                                    newChangeQuestion(e, item.demo_id)
                                  }
                                >
                                  Debit/Credit
                            </button>{" "}
                                <button
                                  type="button"
                                  className={
                                    typeof tempData[item.demo_id] !== "undefined" &&
                                      JSON.parse(tempData[item.demo_id])[1].sel_opt ==
                                      "Bank Transfer"
                                      ? "btnForYesSelected"
                                      : "btnForYes"
                                  }
                                  value="Bank Transfer"
                                  title="Preferred payment type?"
                                  onClick={(e) =>
                                    newChangeQuestion(e, item.demo_id)
                                  }
                                >
                                  Bank Transfer
                            </button>{" "}
                                <button
                                  type="button"
                                  className={
                                    typeof tempData[item.demo_id] !== "undefined" &&
                                      JSON.parse(tempData[item.demo_id])[1].sel_opt ==
                                      "Cash"
                                      ? "btnForYesSelected"
                                      : "btnForYes"
                                  }
                                  value="Cash"
                                  title="Preferred payment type?"
                                  onClick={(e) =>
                                    newChangeQuestion(e, item.demo_id)
                                  }
                                >
                                  Cash
                            </button>
                              </div>
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                      {typeof tempData[item.demo_id] !== "undefined" &&
                        JSON.parse(tempData[item.demo_id])[0].sel_opt == "Yes" &&
                        JSON.parse(tempData[item.demo_id])[1].sel_opt != "" ? (
                          <div>
                            <hr className="hrLine" />
                            <div className="row">
                              <div className="col-md-5">
                                <label>What would be the joining date?</label>
                              </div>
                              <div className="col-md-7">
                                <button
                                  type="button"
                                  className={
                                    typeof tempData[item.demo_id] !== "undefined" &&
                                      JSON.parse(tempData[item.demo_id])[2].sel_opt ==
                                      "This Week"
                                      ? "btnForYesSelected"
                                      : "btnForYes"
                                  }
                                  value="This Week"
                                  title="What would be the joining date?"
                                  onClick={(e) =>
                                    newChangeQuestion(e, item.demo_id)
                                  }
                                >
                                  This Week
                            </button>{" "}
                                <button
                                  type="button"
                                  className={
                                    typeof tempData[item.demo_id] !== "undefined" &&
                                      JSON.parse(tempData[item.demo_id])[2].sel_opt ==
                                      "This Month"
                                      ? "btnForYesSelected"
                                      : "btnForYes"
                                  }
                                  value="This Month"
                                  title="What would be the joining date?"
                                  onClick={(e) =>
                                    newChangeQuestion(e, item.demo_id)
                                  }
                                >
                                  This Month
                            </button>{" "}
                                <button
                                  type="button"
                                  className={
                                    typeof tempData[item.demo_id] !== "undefined" &&
                                      JSON.parse(tempData[item.demo_id])[2].sel_opt ==
                                      "Next Month"
                                      ? "btnForYesSelected"
                                      : "btnForYes"
                                  }
                                  value="Next Month"
                                  title="What would be the joining date?"
                                  onClick={(e) =>
                                    newChangeQuestion(e, item.demo_id)
                                  }
                                >
                                  Next Month
                            </button>{" "}
                              </div>
                            </div>

                            <div className="row justify-content-between">
                              <div className="col-md-3"></div>
                              {typeof faqData[item.demo_id] == "undefined" ? (
                                <div className="col-md-3 text-right">
                                  <button
                                    className="btn btn-primary btn-sm"
                                    onClick={() =>
                                      submitFAQ(
                                        item.user_id,
                                        item.course_id,
                                        item.demo_id
                                      )
                                    }
                                  >
                                    Submit
                              </button>
                                </div>
                              ) : (
                                  ""
                                )}
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                    </fieldset> */}
                  </div>
                </div>
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>

      {afterLeadData.length >= 20 && afterLeadData.length != allLeads ? (
        <div id="loadMore">
          <a onClick={loadMoreFunction}>
            Load More <i className="fas fa-arrow-down"></i>
          </a>
          {loadmoreloader ? (
            <div className="mt-2">
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          ) : (
              ""
            )}
        </div>
      ) : (
          ""
        )}
    </div>
  );
};

export default connect(null, {
  ownLead,
  withDrawLead,
  submitFAQ,
  changeFaqData,
  loadMoreData,
  submitDemoSchedule,
  statusQuestionData,
  getLeadData,
  personalQuestionData,
  getHistoryData,
  getLeadDataFilter,
  getAllCourses,
  SendChangeCourse,
  SendUserName,
  SendMessageToAllTutors,
  intrestedTeachers,
  confirmTutor
})(LeadsInfoTable);
